<template>
    <div class="automation-action-settings">
        <div class="field">
            <small>
                {{ t('automations-form-actions-update_field-snippets_help') }}
            </small>
            <small>
                <ul>
                    <li class="token" v-for="(token, t) in tokens" :key="t">
                        <span class="copy-token">{{ token }}</span>
                        <a @click="copyToken(token)" class="copy-btn"
                            ><i class="fa fa-copy"></i
                        ></a>
                    </li>
                </ul>
            </small>
        </div>
        <div
            v-for="(field, index) in config"
            :key="'field-' + index"
            class="row mb-3 field-to-update"
        >
            <div class="col-12 mb-3">
                <label>{{ t('automations-form-actions-update_field-field_label') }}</label>
                <div>
                    <select
                        class="form-control"
                        v-model="config[index]['fieldId']"
                    >
                        <option value="">{{ t('automations-form-actions-update_field-field_placeholder') }}</option>
                        <option
                            v-for="field in customFields"
                            :value="field.id"
                            :key="'index' + index + '-' + field.id"
                        >
                            {{ field.field_name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-12 mb-3" v-if="config[index]['fieldId']">
                <label>{{ t('automations-form-actions-update_field-update_rule_label') }}</label>
                <div class="inline-labels">
                    <label
                        ><input
                            type="radio"
                            v-model="config[index]['updateRule']"
                            value="always-replace"
                        />
                        {{ t('automations-form-actions-update_field-update_rules-always_replace') }}</label
                    >
                    <label
                        ><input
                            type="radio"
                            v-model="config[index]['updateRule']"
                            value="set-if-empty"
                        />
                        {{ t('automations-form-actions-update_field-update_rules-set_if_empty') }}</label
                    >
                </div>
            </div>
            <div class="col-12 mt-1" v-if="config[index]['fieldId']">
                <div>
                    <template
                        v-if="getFieldType(config[index]['fieldId']) === 'user'"
                    >
                        <div class="inline-labels mb-2">
                            <label
                                ><input
                                    type="radio"
                                    v-model="config[index]['fillRule']"
                                    value="distribute-by-role"
                                />
                                {{ t('automations-form-actions-update_field-fill_rule_distribute') }}</label
                            >
                            <label v-if="userOrderCustomFields.length > 0"
                                ><input
                                    type="radio"
                                    v-model="config[index]['fillRule']"
                                    value="update-with-order-field"
                                />
                                {{ t('automations-form-actions-update_field-fill_rule_order_field') }}
                            </label>
                            <label
                                ><input
                                    type="radio"
                                    v-model="config[index]['fillRule']"
                                    value="manual"
                                />
                                {{ t('automations-form-actions-update_field-fill_rule_manual') }}</label
                            >
                        </div>

                        <template v-if="config[index]['fillRule'] === 'manual'">
                            <label>{{ t('automations-form-actions-update_field-user_manual_label') }}</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="config[index]['value']['text']"
                            />
                            <p class="mt-1 mb-2">
                                <small>{{ t('automations-form-actions-update_field-user_manual_help') }}</small>
                            </p>
                            <select
                                v-if="users && users.length > 0"
                                class="form-control"
                                @change="pickUser(index, $event)"
                            >
                                <option value="">{{ t('automations-form-actions-update_field-user_manual_pick_user') }}</option>
                                <option
                                    v-for="user in users"
                                    :value="user.id"
                                    :key="'user-' + index + '-' + user.id"
                                >
                                    {{ user.name }}
                                </option>
                            </select>
                        </template>
                        <template
                            v-if="
                                config[index]['fillRule'] ===
                                'distribute-by-role'
                            "
                        >
                            <p>
                                {{ t('automations-form-actions-update_field-distribute_help') }}
                            </p>
                            <div class="row">
                                <div class="col-6">
                                    <label> {{ t('automations-form-actions-update_field-branch_label') }} </label>
                                    <select
                                        class="form-control"
                                        v-model="
                                            config[index]['value']['branch']
                                        "
                                    >
                                        <option value="">
                                            {{ t('automations-form-actions-update_field-branch_placeholder') }}
                                        </option>
                                        <option value="any">{{ t('automations-form-actions-update_field-branch_options-any') }}</option>
                                        <option value="last">
                                            {{ t('automations-form-actions-update_field-branch_options-last') }}
                                        </option>
                                        <option value="first">
                                            {{ t('automations-form-actions-update_field-branch_options-first') }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-6">
                                    <label> {{ t('automations-form-actions-update_field-role_label') }} </label>
                                    <select
                                        class="form-control"
                                        v-model="config[index]['value']['role']"
                                    >
                                        <option value="">
                                            {{ t('automations-form-actions-update_field-role_placeholder') }}
                                        </option>
                                        <option value="any">{{ t('automations-form-actions-update_field-role_any') }}</option>
                                        <option
                                            v-for="role in roles"
                                            :value="role.id"
                                            :key="role.id"
                                        >
                                            {{ role.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </template>
                        <template
                            v-if="
                                config[index]['fillRule'] ===
                                'update-with-order-field'
                            "
                        >
                            <select
                                class="form-control"
                                v-model="
                                    config[index]['value']['orders_fields_id']
                                "
                                required
                            >
                                <option value="">{{ t('automations-form-actions-update_field-select_option_placeholder') }}</option>
                                <option
                                    v-for="f in userOrderCustomFields"
                                    :value="f.id"
                                    :key="f.id"
                                >
                                    {{ f.field_name }}
                                </option>
                            </select>
                        </template>
                    </template>
                    <template v-else>
                        <div class="inline-labels mb-2">
                            <label
                                ><input
                                    type="radio"
                                    v-model="config[index]['fillRule']"
                                    value="manual"
                                />
                                {{ t('automations-form-actions-update_field-fill_rule_manual') }}</label
                            >
                            <label
                                v-if="
                                    getOrderFields(
                                        getFieldType(config[index]['fieldId']),
                                    ).length > 0
                                "
                                ><input
                                    type="radio"
                                    v-model="config[index]['fillRule']"
                                    value="update-with-order-field"
                                />
                                {{ t('automations-form-actions-update_field-fill_rule_order_field') }}
                            </label>
                        </div>
                        <template
                            v-if="
                                config[index]['fillRule'] ===
                                'update-with-order-field'
                            "
                        >
                            <select
                                class="form-control"
                                v-model="
                                    config[index]['value']['orders_fields_id']
                                "
                                required
                            >
                                <option value="">{{ t('automations-form-actions-update_field-select_option_placeholder') }}</option>
                                <option
                                    v-for="f in getOrderFields(
                                        getFieldType(config[index]['fieldId']),
                                    )"
                                    :value="f.id"
                                    :key="f.id"
                                >
                                    {{ f.field_name }}
                                </option>
                            </select>
                        </template>
                        <template v-if="config[index]['fillRule'] === 'manual'">
                            <label>{{ t('automations-form-actions-update_field-value_label') }}</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="config[index]['value']['text']"
                            />
                        </template>
                    </template>
                </div>
            </div>
        </div>
        <button class="button btn btn-primary" @click.prevent="addField">
            {{ t('automations-form-actions-update_field-add_field_button') }}
        </button>
        <input id="tokenToCopy" v-model="tokenToCopy" type="text" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {},
        properties: {},
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-update_field-title"),
            description: this.t("automations-form-actions-update_field-description"),
            config: this.properties.config ? [...this.properties.config] : [],
            tokenToCopy: null,
            customFields: [],
            customOrderFields: [],
        };
    },
    mounted: function () {
        this.$store.dispatch("placeDetails/setPlace", this.placeId);
        this.loadFields();
        this.$emit("mounted", this);
    },
    computed: {
        placeId() {
            return this.$store.state.place.id;
        },
        tokens: function () {
            return this.$store.getters["automationForm/tokens"](this.actionId);
        },
        userCustomFields() {
            return this.customFields.filter((f) => f.type === "user");
        },
        userOrderCustomFields() {
            return this.customOrderFields.filter((f) => f.type === "user");
        },
        ...mapState("placeDetails", ["users", "roles", "branches"]),
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        getFieldType(id) {
            if (this.customFields) {
                const f = this.customFields.find((f) => f.id === id);
                if (f) {
                    return f.type;
                }
                return "";
            }
        },
        getOrderFields(type) {
            return this.customOrderFields.filter((f) => f.type === type);
        },
        addField() {
            this.config.push({
                fieldId: "",
                updateRule: "",
                fillRule: "",
                value: {},
            });
        },
        loadFields() {
            const options = keviApi.getOptions("client-fields", "GET");
            this.$http(options).then((response) => {
                this.customFields = response.body;
            });

            const trigger = this.$store.state.automationForm.trigger;
            if (trigger === "new_order" || trigger === "inactivity") {
                const optionsOrders = keviApi.getOptions("order-fields", "GET");
                this.$http(optionsOrders).then((response) => {
                    this.customOrderFields = response.body;
                });
            }
        },
        changed: function () {
            this.$emit("propertiesUpdated", { config: { ...this.config } });
        },
        pickUser(index, event) {
            const userId = event.target.value;
            if (userId) {
                this.$set(this.config[index]["value"], "text", String(userId));
            }
            event.target.value = "";
        },
        isValid: function () {
            const hasEmptyManualUser = this.config.some((fieldConfig) => {
                if (
                    this.getFieldType(fieldConfig.fieldId) !== "user" ||
                    fieldConfig.fillRule !== "manual"
                ) {
                    return false;
                }
                const text = fieldConfig.value ? fieldConfig.value.text : "";
                return !String(text || "").trim();
            });
            return !hasEmptyManualUser;
        },
        copyToken(token) {
            this.tokenToCopy = token;
            this.$nextTick(() => {
                let tokenToCopyInput = document.querySelector("#tokenToCopy");
                tokenToCopyInput.select();
                if (document.execCommand("copy")) {
                    this.$store.dispatch("notification/success", {
                        text: this.t("automations-form-actions-update_field-token_copied"),
                        duration: 5000,
                    });
                }
            });
        },
    },
    watch: {
        config: {
            deep: true,
            handler() {
                this.changed();
            },
        },
        properties: function () {
            if (
                JSON.stringify(this.properties.task) !==
                JSON.stringify(this.task)
            ) {
                this.config = this.properties.config
                    ? [...this.properties.config]
                    : [];
            }
        },
    },
};
</script>
<style scoped lang="less">
.inline-labels label {
    margin-right: 10px;
    margin-bottom: 0;
}

.field-to-update {
    padding-top: 10px;
    padding-bottom: 10px;
    background: #f5f5f5;
    font-size: 12px;
}
</style>
